// extracted by mini-css-extract-plugin
export default {"bodyelement":"Body_bodyelement__mSWcm","vision":"Body_vision__fdK5i","WwhyUsbutton":"Body_WwhyUsbutton__Kqzc2"};